export const ru = {
    adaptive: 'Адаптивный',
    filter: 'Фильтр',
    'sizes-title': 'Размеры'
};
